import { defineStore } from "pinia";

export const useCompareStore = defineStore("compare", {
  state: () => ({
    compares: [],
  }),
});
